/**
 * @module Actions/Application
 * @desc Application Actions
 */
import { ActionTypes } from 'constants/index';
export const loadTheme = (appId) => dispatch => {
    dispatch({ type: ActionTypes.LOAD_THEME_LOADING, appId });
};